import { Component, Input, OnInit } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'topo-phone-column',
    templateUrl: './phone-column.component.html',
    styleUrls: ['./phone-column.component.scss'],
    standalone: false
})
export class PhoneColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
